import React from 'react';
// import {QuoteTable} from "./quoteTable"
import {QuoteForm} from "./quoteForm"
import {useQuoteState} from "./quoteState"



export const QuotePage = () => {
  const { items } = useQuoteState();

  return (
    <>
      <div className={`card quote-card quote-accordion ${items.length === 0 ? 'quote-card--empty' : ''}`}>
        <QuoteForm />
        
        {(items.length === 0) && (
            <div style={{textAlign: "center"}}>
            <p>Your quote is currently empty</p>
            <p><a href="/" className="button button--primary">Continue Shopping</a></p>
            </div>
        )}
      </div>

      
    </>
  );
};
